export default {
  searchId: 'advanced_search',
  title: 'Resultados',
  resourcePath: '/record',
  totalResultsText: 'advancedsearch#works_total',
  grid: 1,
  filters: {
    // title: 'advancedsearch#filters_title',
    valueMap: {
      true: 'Consta',
      false: 'No consta',
      'http*': 'Consta',
      '!*': 'No consta',
    },
    groups: [
      {
        label: 'advancedsearch#label_duracion-obra',
        type: 'term_range_dynamic',
        operator: 'query-durationWork-operator',
        value: 'query-durationWork-value',
        unit: 'query-durationWork-unit',
      },
      {
        label: 'advancedsearch#label_duracion-intervalo',
        type: 'term_range_interval',
        start: 'query-durationWork-intervalo-value-start',
        end: 'query-durationWork-intervalo-value-end',
        unit: 'query-durationWork-intervalo-unit',
      },
    ],
    labels: {
      // Bibliográficos
      'query-titulo': 'advancedsearch#label_titulo',
      'query-authorship': 'advancedsearch#label_autoria',
      'query-authorship-other': 'advancedsearch#label_otros-autores',
      'query-parts': 'advancedsearch#label_parte',
      'query-manuscrito-consta': 'advancedsearch#label_manuscrito',
      'query-manuscrito-tipo': 'advancedsearch#label_manuscrito-tipo',
      'query-biblioteca': 'advancedsearch#label_biblioteca',
      'query-otras-ediciones': 'advancedsearch#label_otras-ediciones',
      'query-otras-ediciones-colecciones-consta': 'advancedsearch#label_otras-ediciones-colecciones',
      'query-otras-ediciones-suelta-consta': 'advancedsearch#label_otras-ediciones-suelta',
      'query-collections': 'advancedsearch#label_colecciones-modernas',
      'query-ediciones-singulares': 'advancedsearch#label_ediciones-singulares',
      'query-ediciones-singulares-consta': 'advancedsearch#label_ediciones-singulares-consta',
      'query-refundiciones-consta': 'advancedsearch#label_refundiciones-consta',
      'query-language': 'advancedsearch#label_refundiciones-lengua',
      'query-refundiciones-autor': 'advancedsearch#label_refundiciones-autor',
      'query-bibliografia-url': 'advancedsearch#label_bibliografia-url',
      'query-bibliografia-autor': 'advancedsearch#label_bibliografia-autor',
      'query-bibliografia-notas': 'advancedsearch#label_bibliografia-notas',
      'query-bibliografia-titulo': 'advancedsearch#label_bibliografia-titulo',
      // Fecha
      'query-fecha': 'advancedsearch#label_fecha',
      metric_metric: 'advancedsearch#label_computo',
      'query-notas': 'advancedsearch#label_notas',
      // Personajes
      'query-espacio-dramaticos': 'advancedsearch#label_espacio-dramaticos',
      'query-espacio-dramaticos-toponimos': 'advancedsearch#label_espacio-dramaticos-toponimos',
      'query-personajes-computables': 'advancedsearch#label_personajes-computables',
      work_character_not_computable: 'advancedsearch#label_personajes-no-computables',
      work_social_universe: 'advancedsearch#label_universo-social',
      chrono_set_period: 'advancedsearch#label_ambientacion-cronologica',
      'query-durationWork': 'advancedsearch#label_duracion-obra',
      'query-durationFirstActPeriod': 'advancedsearch#label_duracion-acto-I',
      'query-durationFirstSecondPeriod': 'advancedsearch#label_duracion-entreacto-I-II',
      'query-durationSecondActPeriod': 'advancedsearch#label_duracion-acto-II',
      'query-durationSecondThirdPeriod': 'advancedsearch#label_duracion-entreacto-II-III',
      'query-durationThirdActPeriod': 'advancedsearch#label_duracion-acto-III',
      // Género
      work_primary_proposal: 'advancedsearch#label_propuesta-generica',
      work_secondary_proposal: 'advancedsearch#label_propuesta-secundaria',
      'query-motivos': 'advancedsearch#label_motivos',
      'query-sinopsis': 'advancedsearch#label_sinopsis',
    },
  },
  sort: {
    label: 'search#sort_title',
    options: [
      // {
      //   value: '_score',
      //   label: 'search#sort_score',
      //   selected: false,
      // },
      {
        value: 'section_ASC',
        label: 'search#sort_asc',
        selected: true,
      },
      {
        value: 'section_DESC',
        label: 'search#sort_desc',
        selected: false,
      },
    ],
  },
  pagination: {
    selectLabel: 'search#results_number',
    limit: 5,
    options: [12, 24, 48],
  },
  itemPreview: {
    // classes: 'is-vertical'
    linkTarget: '_blank',
  },
  highlights: {
    hasToggle: true,
    hidden: true,
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button',
    payload: {
      action: 'redirect',
      url: '/busqueda-avanzada',
    },
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button',
  },
};
